import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.sass';
import './i18n'
import AppComponent from './app.component';
import * as serviceWorker from './serviceWorker';
// eslint-disable-next-line
import 'react-credit-cards/es/styles-compiled.css'

import {Amplify, Storage, Auth} from 'aws-amplify';
import { awsConfig } from './config';
Amplify.configure(awsConfig);
Auth.configure(awsConfig);
Storage.configure(awsConfig);


ReactDOM.render(
  <AppComponent />,
  document.getElementById('root')
);

serviceWorker.unregister();
